import { useEffect, useState } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import ReactTooltip from "react-tooltip";

import { CaseDetailState } from "shared/reducers/caseDetailReducer";
import { SlideDetailState } from "shared/reducers/slideDetailReducer";
import { selectFeatureFlag } from "shared/reducers/sysReducer";

import { useAppSelector } from "store/hooks";

import FlaggingModal from "./modals/FlaggingModal/FlaggingModal";
import { SlideFlagIcon } from "./SlideFlagIcon";

type FlaggingToolProps = {
  slideDetail: SlideDetailState;
  caseDetail: CaseDetailState;
};

const FlaggingTool = ({ caseDetail, slideDetail }: FlaggingToolProps) => {
  const kwonKeys = useAppSelector((state) =>
    selectFeatureFlag(state, "kwonKeys")
  );
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  useEffect(() => {
    setIsModalOpen(false);
  }, [slideDetail.id]);

  useHotkeys(
    "k",
    () => setIsModalOpen((m) => !m),
    { enabled: kwonKeys, scopes: ["viewerHotkeys"] },
    []
  );

  return (
    <>
      <button
        type="button"
        title="flag"
        className={isModalOpen ? "active" : undefined}
        onClick={() => {
          setIsModalOpen(true);
        }}
        data-tip=""
        data-for="button-flag"
      >
        <SlideFlagIcon status="none" />
      </button>
      <ReactTooltip place="bottom" id="button-flag" type="info">
        Flag Slide
      </ReactTooltip>
      {isModalOpen && (
        <FlaggingModal
          caseDetail={caseDetail}
          slideDetail={slideDetail}
          isOpen={isModalOpen}
          setIsOpen={setIsModalOpen}
        />
      )}
    </>
  );
};

export default FlaggingTool;
